export enum CompanyMethod {
  GET_USER_FORM_AVAILABLE_COMPANIES = 'getUserFormAvailableCompanies',
  GET_AVAILABLE_COMPANIES = 'getAvailableCompanies',
}

export interface AvailableCompaniesResponse {
  data: Array<AvailableCompany>;
}

export interface AvailableCompany {
  name: string;
  _id: string;
}
